import {Component, OnInit, HostListener} from '@angular/core'
import {ActivatedRoute, RouterOutlet, Router} from '@angular/router'
import {DomSanitizer, SafeResourceUrl, SafeStyle} from '@angular/platform-browser'
import {Observable} from 'rxjs/Observable'
import {AngularFirestore} from 'angularfire2/firestore'
import {ProjectService} from 'app/project/project.service'

declare var SpatialNavigation: any

const CREATIVECOLLECTION = 'creatives'
const VERSIONSSUBCOLLECTION = 'versions'

@Component({
  selector: 'app-creative',
  templateUrl: './creative.component.html',
  styleUrls: ['./creative.component.scss'],
})
export class CreativeComponent implements OnInit {
  id: string
  creative: any = {}
  next: any = {}
  prev: any = {}
  url: SafeResourceUrl
  background: SafeStyle
  date: string
  versions$: Observable<any[]>

  constructor(public projectService: ProjectService, public firestore: AngularFirestore, public sanitizer: DomSanitizer, public router: Router, public route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.subscribe(({creativeId}) => {
      this.id = creativeId
      this.init(this.projectService.creatives)
      this.versions$ = this.firestore.collection([CREATIVECOLLECTION, creativeId, VERSIONSSUBCOLLECTION].join('/'), ref => ref.orderBy('date', 'desc')).valueChanges()
    })
  }

  init(creatives) {
    for (let i = 0; i < creatives.length; i++) {
      if (creatives[i].id == this.id) {
        this.projectService.currentCreative$.next(+i)
        this.creative = creatives[i]
        this.next = creatives[(i + 1) % creatives.length]
        this.prev = creatives[(i + creatives.length - 1) % creatives.length]
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.creative.url) || this.creative.url
        this.background = this.sanitizer.bypassSecurityTrustStyle(this.creative.fallback) || this.creative.fallback
        this.projectService.focused = [this.id]
        SpatialNavigation.pause()
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  arrowNavigationEvent(event: KeyboardEvent) {
    const KEY_CODE = {
      '37': 'left',
      '38': 'up',
      '39': 'right',
      '40': 'down',
    }
    if (KEY_CODE[event.keyCode]) {
      event.preventDefault()
      event.stopPropagation()
      if (KEY_CODE[event.keyCode] == 'right' || KEY_CODE[event.keyCode] == 'down') this.router.navigate(['../' + this.next.id], {relativeTo: this.route})
      if (KEY_CODE[event.keyCode] == 'left' || KEY_CODE[event.keyCode] == 'up') this.router.navigate(['../' + this.prev.id], {relativeTo: this.route})
    }
  }

  @HostListener('window:keydown', ['$event'])
  spacebarEvent(event: KeyboardEvent) {
    const KEY_CODE = {
      '32': 'spacebar',
    }
    if (KEY_CODE[event.keyCode]) {
      event.preventDefault()
      event.stopPropagation()
      this.projectService.currentCreative$.next(-1)
      this.router.navigate(['../..'], {relativeTo: this.route})
    }
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/creative/creative.component.ts